import { z } from 'zod';
import { DateLikeSchema, IsoDateTimeSchema, UuidSchema, PaginationSchema } from './common.js';
export const TipoPropiedadSchema = z.enum(['home', 'business', 'campo', 'contacto_generico']);
export const PresupuestoEstadoSchema = z.enum(['pendiente', 'en_proceso', 'cerrado', 'descartado']);
export const PresupuestoOrigenSchema = z.enum(['wizard', 'contacto']);
export const PresupuestoSchema = z.object({
    id: UuidSchema,
    nombre: z.string().nullable(),
    email: z.string().nullable(),
    telefono: z.string().nullable(),
    empresa: z.string().nullable(),
    servicio: z.string().nullable(),
    mensaje: z.string().nullable(),
    tipoPropiedad: TipoPropiedadSchema.nullable(),
    respuestas: z.record(z.string(), z.unknown()).nullable(),
    terminosAceptados: z.boolean().nullable(),
    origen: z.string().nullable(),
    estado: PresupuestoEstadoSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
    updatedAt: IsoDateTimeSchema.nullable(),
});
// Cap anti-DoS: o endpoint é público/anônimo; sem limite, `respuestas` (JSONB)
// permite bloat de armazenamento e custo de render no admin (F-21-02).
const RespuestasSchema = z
    .record(z.string(), z.unknown())
    .refine((v) => Object.keys(v).length <= 50 && JSON.stringify(v).length <= 10_000, {
    message: 'respuestas excede o limite (máx. 50 chaves e 10KB serializados)',
});
export const CreatePresupuestoRequestSchema = z.object({
    nombre: z.string().min(1).max(200),
    email: z.string().email().max(200),
    telefono: z.string().max(40).optional(),
    empresa: z.string().max(200).optional(),
    servicio: z.string().max(200).optional(),
    tipoPropiedad: TipoPropiedadSchema,
    respuestas: RespuestasSchema.optional(),
    terminosAceptados: z.literal(true),
    mensaje: z.string().max(2000).optional(),
});
export const UpdatePresupuestoStateRequestSchema = z.object({
    estado: PresupuestoEstadoSchema,
});
export const PresupuestoListQuerySchema = PaginationSchema.extend({
    estado: PresupuestoEstadoSchema.optional(),
    origen: PresupuestoOrigenSchema.optional(),
});
// Contacto — reusa a tabela solicitudes_presupuesto com origen='contacto'.
export const ContactoSchema = PresupuestoSchema;
export const CreateContactoRequestSchema = z.object({
    nombre: z.string().min(1).max(200),
    email: z.string().email().max(200),
    telefono: z.string().max(40).optional(),
    empresa: z.string().max(200).optional(),
    mensaje: z.string().min(1).max(2000),
});
// Pre-reserva VISEP App — tabela própria pre_reservas_app.
export const PreReservaEstadoSchema = z.enum(['pendiente', 'contactado', 'cancelado']);
export const PreReservaSchema = z.object({
    id: UuidSchema,
    nombre: z.string().nullable(),
    email: z.string().nullable(),
    telefono: z.string().nullable(),
    fechaPreferida: z.string().nullable(),
    preferencia: z.string().nullable(),
    origen: z.string().nullable(),
    estado: PreReservaEstadoSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreatePreReservaRequestSchema = z.object({
    nombre: z.string().min(1).max(200),
    email: z.string().email().max(200),
    telefono: z.string().max(40).optional(),
    fechaPreferida: DateLikeSchema.optional(),
    preferencia: z.string().max(500).optional(),
});
export const PreReservaListQuerySchema = PaginationSchema.extend({
    estado: PreReservaEstadoSchema.optional(),
});
// Response schemas dos endpoints públicos de create — validados pelo api-sdk
// (F-22-01). Devem casar com o que `presupuestos/routes.ts` retorna no 201.
export const CreatePresupuestoResponseSchema = z.object({
    id: UuidSchema,
    estado: PresupuestoEstadoSchema.nullable(),
});
export const CreateContactoResponseSchema = z.object({
    id: UuidSchema,
});
export const CreatePreReservaResponseSchema = z.object({
    id: UuidSchema,
});
//# sourceMappingURL=presupuestos.js.map